import * as React from 'react';
import { LANGUAGE_EN } from '../constants';
export var ActiveLangContext = React.createContext(LANGUAGE_EN);
export var ActiveLangProvider = ActiveLangContext.Provider;